/* eslint-disable camelcase */
import { createSelector } from 'reselect';

import {
  getDevice, getPlatform, getBrowser, getFrame, getOrientation,
} from '@ezugi/utils';

import { RootState } from '../types';
import { currentLanguageSelector } from './config';
import { gameSelector } from './game';
import { tableSelector } from './table';
import { userSelector } from './user';

export const initialDataSelector = (state: RootState) => {
  const { operatorId, uid, clientIp, sessionId, currency } = userSelector(state);
  const { name, tableId, limitId } = gameSelector(state);

  const { dealer_id, limits } = tableSelector(state);
  const { Min_Bet: min_limit, Max_Bet: max_limit } = limitId ? limits[limitId]
    : { Min_Bet: undefined, Max_Bet: undefined };

  return {
    player_id: uid,
    language_code: currentLanguageSelector(state).code,
    operator_id: operatorId,
    player_ip: clientIp,
    session_id: sessionId,
    currency,
    game_name: name,
    table_id: tableId,
    limit_id: limitId,
    device: getDevice(),
    browser: getBrowser(),
    frame: getFrame(),
    platform: getPlatform(),
    referral_url: document.referrer,
    created_at: new Date().toUTCString(),
    local_time: new Date().toString(),
    orientation: getOrientation(),
    dealer_id,
    min_limit,
    max_limit,
  };
};

const performanceSelector = (state: RootState) => state.performance;

export const loadTableConfigRequestTimestampSelector = createSelector(
  performanceSelector,
  (performance) => performance.loadTableConfig?.requestTimestamp
);

export const videoRequestTimestampSelector = createSelector(
  performanceSelector,
  (performance) => performance.getVideoRequest?.requestTimestamp
);

export const engineRequestTimestampSelector = createSelector(
  performanceSelector,
  (performance) => performance.engineRequest?.requestTimestamp
);

export const getChatUserRequestTimestampSelector = createSelector(
  performanceSelector,
  (performance) => performance.getChatUserRequest?.requestTimestamp
);
